import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { APP_SETTINGS } from '@services';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { NgIf, NgClass } from '@angular/common';

@Component({
    selector: 'app-user-profile-manager-sidebar',
    templateUrl: './user-profile-manager-sidebar.component.html',
    styleUrls: ['./user-profile-manager-sidebar.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        RouterLink,
        NgClass,
    ],
})
export class UserProfileManagerSidebarComponent implements OnInit {

  public screenWidth: number;
  public section: string;
  APP_SETTINGS;
  public userType: boolean;

  constructor(
    private utilityService: UtilityService,
    private route: ActivatedRoute,
    private router: Router,
    private changeDetector: ChangeDetectorRef) {
    this.screenWidth = this.utilityService.getScreenWidth();
    this.section = this.route.snapshot.paramMap.get('section');
   }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.userType = this.APP_SETTINGS['isExternal'];

    this.router.events.subscribe(event => {
      this.section = this.route.snapshot.paramMap.get('section');
    });
  }

}
